<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
        
            <!-- ********** Main content ********** -->                                                  
                                                                                             
						<div id="main_section">                                                          
                                                                                             
							<!-- Center column (primary content) -->                                       
                                                                                             
							<div id="center_column" heigth="2100px">                                                       
                                                                                             
								<!-- <div id="center_column_inner_wrap"> -->  
							     
							  
	<div id="listings">
		<h1>Publishing Guidelines for the Online Directory</h1>
		<br/>
		<br/>
		The purpose of the following guidelines is to ensure that the information displayed in the Online Directory is accurate and useful to the UC Davis campus and its constituents. <br/>
		<br/>
		<h2>Individuals in the Online Directory</h2>
		<br/>
		<br/>
		The contact information and descriptive content for individuals in the online directory is divided into the &ldquo;Required&rdquo; and &ldquo;Optional&rdquo; categories listed below. <br/>
		<br/>
		<h3>Required Information</h3>
		<ul>
			<li>Name</li>
			<li>Department</li>
			<li>Phone Number</li>
		</ul>
		<h3>Optional Information </h3>
		<ul>
			<li>Address</li>
			<li>E-mail</li>
			<li>Fax</li>
			<li>URL (Web address) - Please do not list non-university-related websites</li>
			<li>Title</li>
		</ul>
		<br/>
		<h2>Departments in the Online Directory</h2>
		<br/>
		<br/>
		To ensure consistent presentation of department contact information, please refrain from entering individual names in the department listings. Titles and office contact information are preferred. Exceptions may be granted for directors, department chairs, etc. Individual names belong in the individual section of the Online Directory . The department contact information and descriptive content stored in the online directory is divided into the required and optional categories listed below. <br/>
		<br/>
		<h3>Required Information</h3>
		<ul>
			<li>Department Name</li>
			<li>Address</li>
			<li>Main Contact Phone Number</li>
		</ul>
		<br/>
		<h3>Optional Information</h3>
		<ul>
			<li>Organizational Units within the department</li>
			<li>Job Titles (such as Chair or Director)</li>
			<li>Department E-mail Addresses</li>
			<li>Fax</li>
			<li>URL (Web address)</li>
		</ul>
		<br/>
		<h2>Search Terms (See Also References)</h2>
		<br/>
		<br/>
		Search terms are words or phrases that individuals may associate with your department. When reviewing your listing, please feel free to recommend any terms that may help people find your department&rsquo;s online listing. These terms can be subjectively linked to your department listing. For example, searching the Online Department Directory for the term &ldquo;pool&rdquo; could return the &ldquo;Schaal Aquatic Center&rdquo; and &ldquo;Campus Recreation&rdquo; department listings. <br/>
		<br/>

	</div>
							  
							     
							    <!-- </div>  -->
							    
							</div>     
										
						</div>			


			</div>  <!-- panel-pane box -->

		</div>
		<!--end .l-content-->

	</div>
</div>

<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>